import { makeStyles } from '@mui/styles'

export default makeStyles((theme) => ({
    root: {
        marginTop: 15,
        marginLeft: 5,
        marginRight: 5
    },
    gridTopOrganization: {
        backgroundColor: theme.palette.color.blue,
        maxHeight: 50,
        padding: 8
    },
    gridTopOnline: {
        backgroundColor: theme.palette.color.green,
        maxHeight: 50,
        padding: 8
    },
    gridTopLocal: {
        backgroundColor: theme.palette.color.orange,
        maxHeight: 50,
        padding: 8
    },
    textTopRight: {
        color: theme.palette.primary.contrastText,
    },
    textTopLeft: {
        color: theme.palette.primary.contrastText,
        textAlign: 'left'
    },
    gridBottom: {
        padding: 10
    },
    literText: {
        fontSize: 15,
        fontWeight: 'bold',
        paddingLeft: 2
    },
    gridBottomText: {
        textAlign: 'left'
    }
}))
